module.exports = __webpack_public_path__ + "img/Tejarat.27e5b609.svg";